<template>
  <div v-if="loaded">
    <sc-panel-navigator
        @update="updateVehicle"
        @delete="removeVehicle">
      <el-card>
        <el-row
            slot="header"
            class="clearfix"
            type="flex">
          <el-col>
            <el-input
                style="width:180px"
                clearable
                v-model="vehicleselect"
                placeholder="search vehicle/emei/phone"></el-input>
            <!--            <s-remote-select-->
            <!--              dark-->
            <!--              style="width: 100%"-->
            <!--              v-model="vehicleselect"-->
            <!--              class-model="assets"-->
            <!--              query-prop="name"-->
            <!--              label-prop="name"-->
            <!--              placeholder="Search for vehicle"-->
            <!--            ></s-remote-select>-->
          </el-col>
          <el-col>
            <el-button
                plain
                type="success"
                @click="goToVehicle('new')">
              <i class="material-icons">add_circle_outline</i> <i class="material-icons">airport_shuttle</i>
            </el-button>
            <!--            <el-button-->
            <!--              plain-->
            <!--              type="success"-->
            <!--              style="float: right"-->
            <!--              @click="goToVehicle('new')"-->
            <!--            >-->
            <!--              <fa icon="plus" fixed-width></fa>-->
            <!--              <fa icon="suitcase-rolling" fixed-width size="lg"></fa>-->
            <!--            </el-button>-->
          </el-col>


        </el-row>
        <el-row>


          <el-checkbox-group
              class="pull-right"
              v-model="archiveLevel">
            <el-checkbox-button
                :label="0"
                key="highpriority">Active
            </el-checkbox-button>
            <el-checkbox-button
                class="pull-right"
                :label="2"
                key="expired">Archived
            </el-checkbox-button>
            <el-checkbox-button
                class="pull-right"
                :label="1"
                key="deleted">Deleted
            </el-checkbox-button>
          </el-checkbox-group>
        </el-row>

        <div class="vehicles">
          <s-table
              ref="vehiclesList"
              :colDefinitions="colVehicleDefinitions"
              modx-processor="assets/getlist"
              :r-query="qVehicles"
              :rowClassFactory="vehicleStyler"
              @cell-clicked="goToVehicle"></s-table>
        </div>
      </el-card>
    </sc-panel-navigator>
  </div>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";

export default {
  mixins: [printHtml],
  data() {
    return {
      printData: null,
      printReady: false,
      loaded: false,
      timelineView: false,
      page: 1,
      vehicleselect: null,
      archiveLevel: [0],
      // bookingRange: [],
      // bookingRangeA: "",
      // bookingRangeZ: "",
      cols: {},
      dateFormat: "DD/MM/YY",
    };
  },
  methods: {
    vehicleStyler(row) {
      if (row.row.archived === 1) return 'deleted'
      if (row.row.archived === 2) return 'archived'
    },
    updateVehicle(e) {
      _log_("update...", e);
      this.$refs.vehiclesList.updateOrAppendRow(e);
    },
    removeVehicle(payload) {
      _log_("dleting...", payload);
      this.routeGo({
        name: "manageVehicle",
        params: {vehicleid: 'all'},
      });
      this.$refs.vehiclesList.reload();
      // this.$refs.vehiclesList.removeRow(payload);
    },
    // async goPrintThis() {
    //   var { data } = await api.fetchProcessor("bookings/vuebookings", {
    //     "bookingRange[]": this.bookingRange,
    //
    //     vehicleselect: this.vehicleselect,
    //     limit: 0,
    //   });
    //   this.printData = data.results;
    //   this.printReady = true;
    // },
    alert(msg) {
      _log_("hell...", msg, this.bookingRangeA.getTime());
    },

    goToVehicle(data) {
      if (data == "new")
        this.routeGo({
          name: "manageVehicle",
          params: {vehicleid: "new"},
        });
      else {
        if (this.$route.params.kind == "package")
          this.routeGo({
            name: "customers",
            params: {vehicleid: data.row ? data.row.id : data},
          });
        else
          this.routeGo({
            name: "manageVehicle",
            params: {vehicleid: data.row ? data.row.id : data},
          });
      }
    },
  },
  async mounted() {
    const date = new Date();
    // this.bookingRange = [
    //   dateHelper.format(dateHelper.startOfToday(), "DD/MM/YYYY"),
    //   dateHelper.format(dateHelper.endOfTomorrow(), "DD/MM/YYYY")
    // ];
    //  [
    //   date.getTime(),
    //   date.getTime() + 3600 * 1000 * 24 * 91
    // ];
    _log_("VEHICLES..", this.$route);

    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  computed: {
    workingKind() {
      _log_("the main params...", this.$route.params);

      if (!this.$route.params.kind) {
        console.error("Route corrupted, no vehicle kind specified");
        return;
      }
      return this.$route.params.kind.toUpperCase();
    },

    // qBookings() {
    //   return { "bookingRange[]": bookingRange, vehicleselect: vehicleselect };
    // },
    qVehicles() {
      _log_(">>Q>>", this.vehicleselect);
      var q = {
        // daterange:
        //   (this.bookingRange[0] ? this.bookingRange[0] : "") +
        //   "-" +
        //   (this.bookingRange[1] ? this.bookingRange[1] : ""),
        // vehicleType: this.workingKind,
      };
      // if (this.vehicleselect) q["excrsid"] = this.vehicleselect;
      if (this.vehicleselect) q["search"] = this.vehicleselect;
      q.archiveLevel = this.archiveLevel
      _log_(">>QP>>", q);
      return q;
    },
    colVehicleDefinitions() {
      var rw = "580px";
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [

        {prop: "name", width: "", label: "Vehicle"},
        {
          prop: "type",
          formatter(v) {
            if (v) return v == 'mini' ? 'MINI BUS' : v.toUpperCase()
          },
          label: "Type",
        },

        {
          prop: "capacity",

          label: "Capacity",
        },
      ];
    },
  },
};
</script>

<style>
.dark .vehicles .deleted {
  text-decoration: line-through;
  background: rebeccapurple;
  color: #e0c5c5;
}

.dark .vehicles .archived {
  background: rebeccapurple;
  color: #e0c5c5;
}

.vehicles .deleted {
  text-decoration: line-through;
  background: rebeccapurple;
  color: #e0c5c5;
}

.vehicles .archived {
  background: rebeccapurple;
  color: #e0c5c5;
}

.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}
</style>
